import { Box, Flex, Text } from "@chakra-ui/react";

const ChatJumpToLatest = ({ count, onClick }) => {
  return (
    <Flex
      position="absolute"
      bottom="8px"
      left="0"
      right="0"
      justify="center"
      pointerEvents="none"
    >
      <Flex
        onClick={onClick}
        pointerEvents="auto"
        cursor="pointer"
        align="center"
        gap="6px"
        bg="dark.500"
        border="1px solid"
        borderColor="dark.400"
        borderRadius="999px"
        px="12px"
        py="5px"
        boxShadow="0 2px 8px rgba(0,0,0,0.4)"
      >
        <Text fontSize="11px" fontWeight="600" color="blue.500">
          {count} new {count === 1 ? "message" : "messages"}
        </Text>
        <Box
          as="svg"
          width="11px"
          height="11px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          color="blue.500"
        >
          <path
            d="M12 4v14m0 0l-6-6m6 6l6-6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default ChatJumpToLatest;
